// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21cIa","comment":"styles_comment__2pEhn"};